// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 机构类型枚举 枚举类
 * 机构类型枚举
 */
export enum EnumOrganizationType {
  /** 企业 : 企业 */
  Company = 1,
  /** 团队 : 团队 */
  Team = 2
}

/**
 * 机构类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumOrganizationTypeMD {
  private static items = [
    new EnumItemMD('Company', 1, '企业', '企业'),
    new EnumItemMD('Team', 2, '团队', '团队')
  ];

  static getItem(enumItem: EnumOrganizationType) {
    return this.items.find(item => item.name === EnumOrganizationType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
